{
  "name": "@org.frb.kc.ads.svc/onecard-frontend",
  "version": "2.0.5-alpha.0",
  "scripts": {
    "ng": "ng",
    "build": "set NODE_OPTIONS=--openssl-legacy-provider && ng build",
    "start": "set NODE_OPTIONS=--openssl-legacy-provider && ng serve",
    "watch": "ng build --watch --configuration development",
    "runlocal": "set NODE_OPTIONS=--openssl-legacy-provider && ng build --configuration development --base-href . --aot --watch",
    "test": "ng test",
    "generate-sbom": "npm sbom --package-lock-only --sbom-format=cyclonedx > target/bom.json"
  },
  "dependencies": {
    "@angular/animations": "^18.2.9",
    "@angular/common": "^18.2.9",
    "@angular/compiler": "^18.2.9",
    "@angular/core": "^18.2.9",
    "@angular/forms": "^18.2.9",
    "@angular/platform-browser": "^18.2.9",
    "@angular/platform-browser-dynamic": "^18.2.9",
    "@angular/router": "^18.2.9",
    "@ng-bootstrap/ng-bootstrap": "^17.0.0",
    "@ngrx/store": "^18.1.0",
    "bootstrap": "^4.5.0",
    "core-js": "^2.5.4",
    "font-awesome": "^4.7.0",
    "jquery": "^3.5.1",
    "jquery-ui-dist": "^1.12.1",
    "ng2-cookies": "^1.0.12",
    "ng5-auto-complete": "0.0.8",
    "ngx-bootstrap": "^18.0.0",
    "ngx-toastr": "^19.0.0",
    "popper.js": "^1.16.1",
    "postcss": "^8.4.49",
    "rxjs": "~7.8.0",
    "toastr": "^2.1.4",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.10",
    "@angular/cli": "^18.2.10",
    "@angular/compiler-cli": "^18.2.9",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^12.11.1",
    "codelyzer": "^6.0.0",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "protractor": "~7.0.0",
    "ts-node": "~8.3.0",
    "tslint": "~6.1.0",
    "typescript": "~5.5.2"
  }
}
